"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _kycActions = require("../actions/kycActions");
var _kycManualActions = require("../actions/kycManualActions");
var _verifyEmailActions = require("../actions/verifyEmailActions");
var _resetPasswordActions = require("../actions/resetPasswordActions");
var _confirmWithdrawActions = require("../actions/confirmWithdrawActions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  processingValidateUserRegistration: false,
  processingSetUserConfig: false,
  processingVerifyEmail: false,
  processingResetPassword: false,
  processingConfirmWithdraw: false,
  processingVerifyAddress: false,
  processingVerifyDevice: false
};
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type;
  switch (type) {
    case _confirmWithdrawActions.PROCESSING_VERIFY_ADDRESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingVerifyAddress: true
      });
    case _confirmWithdrawActions.FINISHED_VERIFY_ADDRESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingVerifyAddress: false
      });
    case _kycActions.PROCESSING_VALIDATE_USER_REGISTRATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingValidateUserRegistration: true
      });
    case _kycActions.FINISHED_VALIDATE_USER_REGISTRATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingValidateUserRegistration: false
      });
    case _kycManualActions.PROCESSING_SET_USER_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingSetUserConfig: true
      });
    case _kycManualActions.FINISHED_SET_USER_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingSetUserConfig: false
      });
    case _verifyEmailActions.PROCESSING_VERIFY_EMAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingVerifyEmail: true
      });
    case _verifyEmailActions.FINISHED_VERIFY_EMAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingVerifyEmail: false
      });
    case _resetPasswordActions.PROCESSING_RESET_PASSWORD:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingResetPassword: true
      });
    case _resetPasswordActions.FINISHED_RESET_PASSWORD:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingResetPassword: false
      });
    case _confirmWithdrawActions.PROCESSING_CONFIRM_WITHDRAW:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingConfirmWithdraw: true
      });
    case _confirmWithdrawActions.FINISHED_CONFIRM_WITHDRAW:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingConfirmWithdraw: false
      });
    case _confirmWithdrawActions.PROCESSING_VERIFY_DEVICE:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingVerifyDevice: true
      });
    case _confirmWithdrawActions.FINISHED_VERIFY_DEVICE:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingVerifyDevice: false
      });
    default:
      return state;
  }
}